import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import {
  classReportDetails,
  readingCohorts,
} from "../../../utils/CommonUtils/constants";
import useParamValues from "../../../utils/useParamValues";
import useTranslationSetup from "../../../utils/useTranslationSetup";
import "./styles.css";

const CohortisedStudentList = ({ cohorts, pageIndex, classLength }) => {
  const { t, tSubject } = useTranslationSetup();
  const useParamValue = useParamValues();
  const isFirstPage = pageIndex === 0;
  const classReportInfo = classReportDetails(t, classLength, useParamValue);
  const classInfo = [classReportInfo[0], classReportInfo[2]];

  const maxRows = Math.max(...Object.values(cohorts).map((c) => c.length));

  return (
    <>
      <Box className="cohortised-student-list-container">
        <Box className="class-details-container">
          {classInfo.map((item, index) => (
            <Box className="class-details-grid-item" key={index}>
              <Typography className="class-details-grid-item-label">
                {item.label}
              </Typography>
              <Typography className="class-details-grid-item-value">
                {item.value}
              </Typography>
            </Box>
          ))}
        </Box>
        {isFirstPage && (
          <Typography className="class-details-class-section">
            {`${t("class")} ${useParamValue?.classNum} - ${t("section")} ${useParamValue?.section}`}
          </Typography>
        )}
        <Box
          className={`class-details-cohort-header-container ${!isFirstPage && "add-padding"}`}
        >
          {readingCohorts(tSubject).map((item, index) => (
            <Box
              className={`class-details-cohort-header-item bg-color-${index}`}
              key={index}
            >
              <Typography className="class-details-cohort-header-item-label">
                {item.label}
              </Typography>
              <img
                src={item.icon}
                className="class-details-cohort-header-item-icon"
                alt="cohort-icon"
              />
            </Box>
          ))}
        </Box>
        <Box>
          <Table className="class-details-result-metric-table">
            <TableBody>
              {Array.from({ length: maxRows }).map((_, i) => (
                <TableRow
                  className={`${i % 2 !== 0 && "class-details-result-metric-table-body-row"}`}
                  key={i}
                >
                  {[1, 2, 3, 4].map((c) => (
                    <TableCell
                      className="class-details-result-metric-table-body-cell"
                      key={c}
                    >
                      {cohorts[c][i]?.name || ""}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Box>
    </>
  );
};

export default CohortisedStudentList;
